import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "chat-layout" }
const _hoisted_2 = { class: "chat-container" }
const _hoisted_3 = { class: "friends-panel" }
const _hoisted_4 = { class: "friends-header" }
const _hoisted_5 = { class: "friends-search" }
const _hoisted_6 = { class: "friends-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "friend-info" }
const _hoisted_9 = { class: "friend-details" }
const _hoisted_10 = { class: "last-message" }
const _hoisted_11 = { class: "message-time" }
const _hoisted_12 = {
  key: 0,
  class: "chat-panel"
}
const _hoisted_13 = { class: "chat-header" }
const _hoisted_14 = { class: "friend-info" }
const _hoisted_15 = { class: "username" }
const _hoisted_16 = { class: "header-actions" }
const _hoisted_17 = {
  key: 0,
  class: "load-more-container"
}
const _hoisted_18 = {
  key: 1,
  class: "loading-tips"
}
const _hoisted_19 = {
  key: 0,
  class: "message-bubble other-bubble"
}
const _hoisted_20 = { class: "sender-info" }
const _hoisted_21 = { class: "sender-name" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "message-content" }
const _hoisted_24 = { class: "message-status" }
const _hoisted_25 = { class: "message-time" }
const _hoisted_26 = { class: "other-message-read-status" }
const _hoisted_27 = {
  key: 1,
  class: "message-bubble my-bubble"
}
const _hoisted_28 = { class: "sender-info-my" }
const _hoisted_29 = { class: "sender-name-my" }
const _hoisted_30 = { class: "message-content-wrapper" }
const _hoisted_31 = { class: "message-content" }
const _hoisted_32 = { class: "message-status" }
const _hoisted_33 = { class: "message-time" }
const _hoisted_34 = { class: "my-message-read-status" }
const _hoisted_35 = { class: "chat-input-area" }
const _hoisted_36 = { class: "send-btn-container" }
const _hoisted_37 = {
  key: 1,
  class: "welcome-panel"
}

import { ref, onMounted, onUnmounted, computed, nextTick, reactive, triggerRef, watch } from 'vue';
import { useStore } from 'vuex';
import { ElMessage, ElBadge, ElMessageBox } from 'element-plus';
import { 
  sendUserMessage, 
  getUserMessagePage, 
  markMessageAsRead,
  batchMarkMessageAsRead
} from '@/user/api/interaction';
import { getUserFriends } from '@/user/api/userApi';
import { formatPostDate } from '@/utils/date';
import GlobalChatWebSocketService, { ChatMessage, ReadStatusMessage } from '@/user/services/globalChatService'; // 使用全局服务

interface Friend {
  id: number;
  name: string;
  avatar: string;
  lastMessageContent: string;
  lastMessageTime:string;
  unreadMessageCount: number;
}

interface Message {
  id: number;
  fromUserId: number;
  fromUserName: string;
  fromUserAvatar: string;
  content: string;
  createTime: string;
  isRead: number; // 新增字段 0未读1已读
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatView',
  setup(__props) {

const store = useStore();
const messagesContainerRef = ref<HTMLDivElement|null>(null);
const searchQuery = ref('');
const wsConnected = ref(false);

// 添加本地消息ID映射，用于关联本地临时ID和服务器真实ID
const localToServerIdMap = new Map<number, number>(); // 本地ID -> 服务器ID

// 好友列表
const friendsList = ref<Friend[]>([]);
const selectedFriend = ref<Friend | null>(null);

// 消息状态
const state = reactive({
  inputMessage: '',
  messages: [] as Message[],
  loadingMore: false,
  currentPage: 0,
  hasMore: true
});

// 计算属性
const currentUserInfo = computed(() => {
  const info = store.state.userInfo;
  console.log('当前用户信息:', info);
  return info;
});
const filteredFriends = computed(() => {
  if (!searchQuery.value) {
    return friendsList.value;
  }
  return friendsList.value.filter(friend => 
    friend.name.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});

// 选择好友
const selectFriend = async (friend: Friend) => {
  const previousFriendId = selectedFriend.value?.id;
  selectedFriend.value = friend;
  
  // 如果切换了好友，且之前的已选好友存在，可以尝试刷新其未读数（可选优化）
  
  // 重置消息状态
  state.messages = [];
  state.currentPage = 0;
  state.hasMore = true;
  
  // 加载该好友的消息，首次加载时滚动到底部
  await loadMessagesForFriend(friend.id, true);
  
  // 标记该好友的所有未读消息为已读
  if (friend.id) {
    try {
      // 获取与该好友的所有未读消息
      const friendUnreadMessages = state.messages.filter(msg => 
        msg.fromUserId === friend.id && msg.isRead === 0
      );
      const unreadMessageIds = friendUnreadMessages.map(msg => msg.id);
      
      if (unreadMessageIds.length > 0) {
        // 批量标记为已读
        await batchMarkMessageAsRead(unreadMessageIds);
        // 更新本地状态
        friendUnreadMessages.forEach(msg => {
          msg.isRead = 1;
        });
        triggerRef(state);
      }
      
      // 重要：根据实际标记为已读的消息数来扣减好友列表中的未读消息数
      // 避免直接清零，而是扣减已读消息数
      const friendInList = friendsList.value.find(f => f.id === friend.id);
      if (friendInList) {
        // 确保未读数不会变成负数
        friendInList.unreadMessageCount = Math.max(0, friendInList.unreadMessageCount - unreadMessageIds.length);
      }
    } catch (error) {
      console.error('批量标记消息已读失败:', error);
    }
  }
  
  // 滚动到底部
  scrollToBottom();
};

// 监听消息容器滚动事件，实现无感加载
const handleScroll = async (event: Event) => {
  const container = event.target as HTMLElement;
  
  // 由于现在消息是按时间正序排列，最早的在上，最新的在下
  // 当接近顶部时，说明用户想查看更早的消息
  if (container.scrollTop <= 200 && state.hasMore && !state.loadingMore) {
    console.log('滚动到顶部，加载更多消息');
    
    // 记录当前滚动位置
    const prevScrollHeight = container.scrollHeight;
    const prevScrollTop = container.scrollTop;
    
    await loadMoreMessages();
    
    // 等待 DOM 更新后，调整滚动位置以保持视觉连续性
    await nextTick(() => {
      // 计算需要补偿的高度差，以保持滚动位置不变
      const heightDiff = container.scrollHeight - prevScrollHeight;
      container.scrollTop = prevScrollTop + heightDiff;
    });
  }
};

// 格式化时间
const formatDate = (dateStr: string) => {
  return formatPostDate(dateStr);
};

// 获取头像
const getAvatarByUserId = (userId: number) => {
  if (userId === selectedFriend.value?.id) {
    return selectedFriend.value.avatar;
  }
  if (userId === currentUserInfo.value?.id) {
    return currentUserInfo.value?.avatar;
  }
  return null;
};

// 发送消息
const sendMessage = async () => {
  if (!state.inputMessage.trim()) {
    ElMessage.warning('请输入消息内容');
    return;
  }

  if (!selectedFriend.value) {
    ElMessage.warning('请选择好友');
    return;
  }

  const messageContent = state.inputMessage;
  
  try {
    // 检查当前用户信息是否存在
    if (!currentUserInfo.value) {
      ElMessage.error('用户未登录，无法发送消息');
      return;
    }

    // 生成一个临时ID用于本地显示
    const tempId = Date.now();
    
    // 构建临时消息对象
    const tempMessage: Message = {
      id: tempId,
      fromUserId: currentUserInfo.value.id,
      fromUserName: currentUserInfo.value.name || '我',
      fromUserAvatar: currentUserInfo.value.avatar,
      content: messageContent,
      createTime: new Date().toISOString(),
      isRead: 0 // 发送的消息初始状态为未读
    };
    
    // 添加到本地消息列表
    state.messages.push(tempMessage);
    
    // 滚动到底部
    scrollToBottom();
    
    // 发送消息到服务器
    const response = await sendUserMessage({
      toUserId: selectedFriend.value.id,
      content: messageContent
    });

    if (response.code === 1) {
      // 服务器返回真实ID后，更新本地消息的ID
      // 根据后端返回格式，response.data 直接是 ID 数字
      const realMessageId = response.data;
      if (realMessageId) {
        // 更新ID映射
        localToServerIdMap.set(tempId, realMessageId);
        
        // 更新本地消息的真实ID
        const messageIndex = state.messages.findIndex(msg => msg.id === tempId);
        if (messageIndex !== -1) {
          state.messages[messageIndex].id = realMessageId;
          console.log(`消息ID从 ${tempId} 更新为 ${realMessageId}`);
        }
      }
      
      // 清空输入框
      state.inputMessage = '';
      
      ElMessage.success('消息发送成功');
    } else {
      // 如果发送失败，移除本地临时消息
      const messageIndex = state.messages.findIndex(msg => msg.id === tempId);
      if (messageIndex !== -1) {
        state.messages.splice(messageIndex, 1);
      }
      ElMessage.error(response.msg || '消息发送失败');
    }
  } catch (error) {
    console.error('发送消息失败:', error);
    // 如果发生异常，也尝试移除可能已添加的临时消息（虽然通常在try块内处理）
    // 这里简单处理，主要依靠catch捕获网络错误等
    ElMessage.error('发送消息失败，请检查网络连接');
  }
};

// 处理发送快捷键
const handleSendWithKeydown = (event: KeyboardEvent) => {
  if (event.shiftKey) return; // 如果按下Shift键，不触发发送
  event.preventDefault(); // 阻止换行
  sendMessage();
};

// 加载与指定好友的消息
const loadMessagesForFriend = async (userId: number, scrollToBottomOnFirstLoad = true) => {
  if (state.loadingMore) return;
  
  const isFirstLoad = state.currentPage === 0; // 判断是否是首次加载
  
  state.loadingMore = true;
  
  try {
    const params = {
      page: state.currentPage + 1,
      pageSize: 20,
      targetUserId: userId
    };

    const response = await getUserMessagePage(params);

    if (response.code === 1) {
      const newMessages = response.data?.records || [];
      
      // 将新获取的历史消息添加到现有消息前面
      state.messages.unshift(...newMessages);
      
      // 按时间戳对所有消息进行排序，确保时间正序（从早到晚）
      state.messages.sort((a, b) => new Date(a.createTime).getTime() - new Date(b.createTime).getTime());
      
      // 更新页码和是否有更多数据的标志
      state.currentPage++;
      state.hasMore = newMessages.length === params.pageSize;
    } else {
      ElMessage.error(response.msg || '获取消息失败');
    }
  } catch (error) {
    console.error('加载消息失败:', error);
    ElMessage.error('加载消息失败');
  } finally {
    state.loadingMore = false;
    // 等待DOM更新后再滚动
    await nextTick();
    
    // 首次加载时滚动到底部
    // 加载更多历史消息时，由 handleScroll 负责恢复滚动位置，此处不进行滚动操作以避免冲突
    if (isFirstLoad && scrollToBottomOnFirstLoad) {
      scrollToBottom();
    }
  }
};

// 加载更多消息
const loadMoreMessages = async () => {
  if (state.loadingMore || !selectedFriend.value) return;

  state.loadingMore = true;
  try {
    const response = await getUserMessagePage({
      page: state.currentPage + 1,
      pageSize: 20,
      targetUserId: selectedFriend.value.id
    });

    if (response.code === 1) {
      const newMessages = response.data.records.map((record: any) => ({
        id: record.id,
        fromUserId: record.fromUserId,
        fromUserName: record.fromUserName,
        fromUserAvatar: record.fromUserAvatar,
        content: record.content,
        createTime: record.createTime,
        isRead: record.isRead
      }));

      // 按时间顺序排序（最早的在前，最新的在后）
      newMessages.sort((a, b) => new Date(a.createTime).getTime() - new Date(b.createTime).getTime());

      // 将新获取的消息添加到现有消息列表前面
      state.messages = [...newMessages, ...state.messages];

      // 更新分页信息
      state.currentPage++;
      state.hasMore = response.data.records.length === 20;

      // 标记新加载的未读消息为已读
      const unreadMessages = newMessages.filter(msg => msg.isRead === 0);
      if (unreadMessages.length > 0) {
        // 提取未读消息ID
        const unreadMessageIds = unreadMessages.map(msg => msg.id);
        
        try {
          // 批量标记为已读
          await batchMarkMessageAsRead(unreadMessageIds);
          
          // 更新本地消息状态
          state.messages.forEach(msg => {
            if (unreadMessageIds.includes(msg.id)) {
              msg.isRead = 1;
            }
          });
          
          // 重要：更新好友列表中的未读消息数
          const friendInList = friendsList.value.find(f => f.id === selectedFriend.value!.id);
          if (friendInList) {
            friendInList.unreadMessageCount = Math.max(0, friendInList.unreadMessageCount - unreadMessageIds.length);
          }
          
          console.log(`批量标记 ${unreadMessageIds.length} 条历史消息为已读`);
        } catch (error) {
          console.error('批量标记历史消息为已读失败:', error);
        }
      }
    }
  } catch (error) {
    console.error('加载更多消息失败:', error);
    ElMessage.error('加载更多消息失败');
  } finally {
    state.loadingMore = false;
  }
};

// 滚动到底部
const scrollToBottom = () => {
  nextTick(() => {
    if (messagesContainerRef.value) {
      messagesContainerRef.value.scrollTop = messagesContainerRef.value.scrollHeight;
    }
  });
};

// 滚动到顶部
const scrollToTop = () => {
  nextTick(() => {
    if (messagesContainerRef.value) {
      messagesContainerRef.value.scrollTop = 0;
    }
  });
};

// 标记单条消息为已读
const markSingleMessageAsRead = async (message: Message) => {
  // 只处理接收的消息，且是未读状态
  if (message.fromUserId !== currentUserInfo.value?.id && message.isRead === 0) {
    try {
      await markMessageAsRead(message.id);
      // 更新本地消息状态
      message.isRead = 1;
      triggerRef(state);
      console.log(`消息 ${message.id} 标记为已读成功`);
    } catch (error) {
      console.error(`标记消息 ${message.id} 为已读失败:`, error);
      ElMessage.error('标记消息为已读失败');
    }
  }
};

// 批量标记消息为已读
const markBatchMessagesAsRead = async (messagesToMark: Message[]) => {
  if (!messagesToMark || messagesToMark.length === 0) {
    ElMessage.warning('没有需要标记的消息');
    return;
  }

  // 过滤出未读的接收消息
  const unreadMessages = messagesToMark.filter(
    msg => msg.fromUserId !== currentUserInfo.value?.id && msg.isRead === 0
  );

  if (unreadMessages.length === 0) {
    ElMessage.info('没有未读消息需要标记');
    return;
  }

  const messageIds = unreadMessages.map(msg => msg.id);

  try {
    await batchMarkMessageAsRead(messageIds);
    
    // 更新本地消息状态
    unreadMessages.forEach(msg => {
      msg.isRead = 1;
    });
    triggerRef(state);
    
    ElMessage.success(`成功标记 ${unreadMessages.length} 条消息为已读`);
  } catch (error) {
    console.error('批量标记消息为已读失败:', error);
    ElMessage.error('批量标记消息为已读失败');
  }
};

// 标记当前会话所有未读消息为已读
const markAllUnreadAsRead = async () => {
  if (!selectedFriend.value) {
    ElMessage.warning('请先选择好友');
    return;
  }

  // 获取当前会话中所有未读的接收消息
  const unreadMessages = state.messages.filter(
    msg => msg.fromUserId === selectedFriend.value?.id && msg.isRead === 0
  );

  if (unreadMessages.length === 0) {
    ElMessage.info('没有未读消息');
    return;
  }

  try {
    // 确认操作
    await ElMessageBox.confirm(
      `确定要将与 ${selectedFriend.value.name} 的 ${unreadMessages.length} 条消息标记为已读吗？`,
      '确认标记',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    );

    const messageIds = unreadMessages.map(msg => msg.id);
    await batchMarkMessageAsRead(messageIds);

    // 更新本地消息状态
    unreadMessages.forEach(msg => {
      msg.isRead = 1;
    });
    triggerRef(state);

    ElMessage.success(`成功标记 ${unreadMessages.length} 条消息为已读`);
  } catch (error) {
    if (error !== 'cancel') {
      console.error('批量标记所有未读消息失败:', error);
      ElMessage.error('批量标记失败');
    }
  }
};

// 处理接收到的新消息
const handleNewMessage = async (message: ChatMessage) => {
  console.log('收到新消息:', message);
  
  // 查找发送者是否在好友列表中
  const friendIndex = friendsList.value.findIndex(f => f.id === message.fromUserId);
  const friend = friendIndex !== -1 ? friendsList.value[friendIndex] : null;

  // 更新好友列表中的最后消息信息和未读数
  if (friend) {
    friend.lastMessageContent = message.content;
    friend.lastMessageTime = message.createTime;
    
    // 如果当前没有选中该好友，或者该消息不是当前激活窗口发出的（即后台接收），增加未读数
    // 注意：通常自己发的消息不会通过WS推给自己作为"新消息"提醒，除非是多端同步.
    // 假设 message.fromUserId !== currentUserInfo.value.id
    if (selectedFriend.value?.id !== message.fromUserId) {
      friend.unreadMessageCount = (friend.unreadMessageCount || 0) + 1;
      
      // 可选：播放提示音或显示通知
    } else {
      // 如果当前正与该好友聊天，收到对方消息，标记为已读
      // 这里主要是确保UI上未读数归零
      friend.unreadMessageCount = 0;
    }
  } else {
    // 如果不在好友列表中（例如陌生人消息，视业务逻辑而定），可能需要重新加载好友列表或忽略
    console.warn('收到非好友列表用户的消息:', message.fromUserId);
  }

  // 如果是当前聊天对象发来的消息，添加到当前消息列表
  if (selectedFriend.value && message.fromUserId === selectedFriend.value.id) {
    // 如果WebSocket消息中的用户名或头像为空，尝试从好友列表中获取
    const newMessage: Message = {
      id: message.id,
      fromUserId: message.fromUserId,
      fromUserName: message.fromUserName || friend?.name || selectedFriend.value.name || '未知用户',
      fromUserAvatar: message.fromUserAvatar || friend?.avatar || selectedFriend.value.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
      content: message.content,
      createTime: message.createTime,
      isRead: 1 // 新收到的消息默认为未读
    };
    
    state.messages.push(newMessage);
    scrollToBottom();
    
    // 关键修改：标记这条具体的单条消息为已读
    try {
      await markMessageAsRead(newMessage.id);
      // 更新本地消息状态
      newMessage.isRead = 1;
      triggerRef(state);
      console.log(`实时收到的消息 ${newMessage.id} 已标记为已读`);
    } catch (error) {
      console.error(`标记实时消息 ${newMessage.id} 为已读失败:`, error);
    }
  }
};

// 处理消息已读状态更新
const handleReadStatusUpdate = (readStatus: ReadStatusMessage) => {
  console.log('收到消息已读状态更新:', readStatus);
  
  // 首先尝试直接查找服务器ID对应的消息
  let messageIndex = state.messages.findIndex(msg => msg.id === readStatus.messageId);
  
  // 如果没找到，检查是否是本地ID映射
  if (messageIndex === -1) {
    // 遍历本地ID映射，看是否有对应的服务器ID
    for (const [localId, serverId] of localToServerIdMap.entries()) {
      if (serverId === readStatus.messageId) {
        // 找到了对应的本地ID，查找消息
        messageIndex = state.messages.findIndex(msg => msg.id === localId);
        if (messageIndex !== -1) {
          break;
        }
      }
    }
  }
  
  if (messageIndex !== -1) {
    // 更新消息的已读状态
    state.messages[messageIndex].isRead = 1;
    console.log(`消息 ${readStatus.messageId} 状态更新为已读`);
    // 触发响应式更新
    triggerRef(state);
  } else {
    console.warn(`未找到ID为 ${readStatus.messageId} 的消息，可能已过期或不在此会话中`);
  }
};

// 处理批量消息已读状态更新
const handleBatchReadStatusUpdate = (batchReadStatus: any) => {
  console.log('收到批量消息已读状态更新:', batchReadStatus);
  
  // 根据日志，这里的数据结构可能已经是解析后的对象，不需要再访问.data
  // 所以我们直接使用传入的 batchReadStatus 作为数据
  const data = batchReadStatus;
  
  // 检查数据结构是否符合预期
  if (!data || !data.messages) {
    console.error('批量已读状态数据格式错误:', batchReadStatus);
    return;
  }
  
  // 遍历消息数组，逐条更新本地消息列表的isRead状态
  data.messages.forEach((message: { messageId: number, content: string }) => {
    let messageIndex = state.messages.findIndex(msg => msg.id === message.messageId);
    
    // 如果没找到，检查是否是本地ID映射
    if (messageIndex === -1) {
      // 遍历本地ID映射，看是否有对应的服务器ID
      for (const [localId, serverId] of localToServerIdMap.entries()) {
        if (serverId === message.messageId) {
          // 找到了对应的本地ID，查找消息
          messageIndex = state.messages.findIndex(msg => msg.id === localId);
          if (messageIndex !== -1) {
            break;
          }
        }
      }
    }
    
    if (messageIndex !== -1) {
      // 更新消息的已读状态
      state.messages[messageIndex].isRead = 1;
      console.log(`消息 ${message.messageId} 状态更新为已读`);
    } else {
      console.warn(`未找到ID为 ${message.messageId} 的消息，可能已过期或不在此会话中`);
    }
  });
  
  // 触发响应式更新
  triggerRef(state);
  
  console.log(`批量更新了 ${data.messages.length} 条消息的已读状态`);
};

// 监听好友选择变化
watch(selectedFriend, (newVal) => {
  if (newVal) {
    scrollToBottom();
  }
}, { immediate: true });

// 初始化WebSocket连接
const initWebSocket = () => {
  // 获取token并建立WebSocket连接
  const token = store.state.token || localStorage.getItem('token');
  if (token) {
    console.log('正在连接WebSocket...');
    // 实际建立WebSocket连接
    GlobalChatWebSocketService.connect(token);
    
    // 添加消息处理器
    GlobalChatWebSocketService.addMessageHandler(handleNewMessage);
    // 添加消息已读状态处理器
    GlobalChatWebSocketService.addReadStatusHandler(handleReadStatusUpdate);
    
    // 添加批量消息已读状态处理器
    GlobalChatWebSocketService.addBatchReadStatusHandler(handleBatchReadStatusUpdate);
    
    // 添加连接状态监听
    GlobalChatWebSocketService.addConnectionHandler((connected) => {
      wsConnected.value = connected;
      console.log('WebSocket连接状态变更:', connected ? '已连接' : '未连接');
    });
    
    // 初始同步状态
    wsConnected.value = GlobalChatWebSocketService.isConnected();
  } else {
    console.warn('未找到token，无法建立WebSocket连接');
  }
};

// 加载好友列表
const loadFriends = async () => {
  try {
    const params = {
      page: 1,
      pageSize: 100  // 获取所有好友
    };
    
    console.log('正在请求好友列表，参数:', params);
    const response = await getUserFriends(params);
    console.log('获取好友列表响应:', response);
    
    let friends = [];
    
    if (response && typeof response === 'object' && 'code' in response) {
      if (response.code === 1) {
        friends = response.data?.records || [];
        console.log('加载的好友数量:', friends.length);
      } else {
        // 如果后端返回错误信息，则显示具体错误
        ElMessage.error(response.msg || '获取好友列表失败');
        console.error('获取好友列表失败:', response.msg);
        loadMockFriends();
        return;
      }
    } else {
      // 响应可能是直接的数据，没有code包装
      friends = response?.records || response || [];
      console.log('直接加载好友列表，数量:', friends.length);
    }

    // 获取每个好友的未读消息数 (如果API支持批量获取最好，否则可能需要单独请求或依赖WS更新)
    // 这里假设 getUserFriends 返回的数据里可能不包含实时未读数，或者我们需要额外请求
    // 为了简化，先赋值基础信息，然后尝试获取未读数映射（如果有这样的API）
    // 如果没有批量获取未读数的API，可以在循环中调用 getUnreadMessageCount (不推荐，性能差)
    // 或者依赖 WebSocket 推送来更新未读数，初始设为0
    
    friendsList.value = friends.map((f: any) => ({
      ...f,
      unreadMessageCount: f.unreadMessageCount || 0 // 初始化为0，等待WS更新或单独接口
    }));

    // 可选：如果有一个获取所有未读数的接口，可以在这里调用并合并数据
    // try {
    //   const unreadRes = await getUnreadMessageCount();
    //   if(unreadRes.code === 1) {
    //      // 合并 unreadRes.data 到 friendsList
    //   }
    // } catch(e) {}

  } catch (error: any) {
    console.error('获取好友列表失败:', error);
    if (error.response) {
      console.error('响应错误:', error.response.status, error.response.data);
      ElMessage.error(`获取好友列表失败: ${error.response.status} ${error.response.statusText}`);
    } else if (error.request) {
      console.error('请求错误:', error.request);
      ElMessage.error('网络错误，请检查网络连接');
    } else {
      console.error('其他错误:', error.message);
      ElMessage.error('获取好友列表失败: ' + error.message);
    }
    
    // 使用模拟数据作为后备方案
    loadMockFriends();
  }
};

// 模拟好友数据的函数
const loadMockFriends = () => {
  console.warn('使用模拟好友数据');
  friendsList.value = [
    { id: 1, name: '张三', avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png', lastMessageContent:'你好！', lastMessageTime: new Date().toISOString() ,unreadMessageCount: 0} ,
    { id: 2, name: '李四', avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png', lastMessageContent:'你好！', lastMessageTime: new Date().toISOString() ,unreadMessageCount: 0} ,
    { id:3, name: '王五', avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png', lastMessageContent:'你好！', lastMessageTime: new Date().toISOString() ,unreadMessageCount: 0}
  ];
};

// 初始化
onMounted(async () => {
  console.log('ChatView组件挂载，开始初始化');
  await loadFriends();
  console.log('好友列表加载完成，添加WebSocket处理器');
  initWebSocket();
});

// 页面卸载时清理
onUnmounted(() => {
  console.log('ChatView组件卸载，移除WebSocket处理器');
  GlobalChatWebSocketService.removeMessageHandler(handleNewMessage);
  GlobalChatWebSocketService.removeReadStatusHandler(handleReadStatusUpdate);
  // 不断开连接，因为其他组件也可能在使用
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h3", null, "我的好友", -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["connection-status", { connected: wsConnected.value }])
          }, _toDisplayString(wsConnected.value ? '已连接' : '未连接'), 3)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_input, {
            modelValue: searchQuery.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            placeholder: "搜索好友...",
            "prefix-icon": "Search"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFriends.value, (friend) => {
            return (_openBlock(), _createElementBlock("div", {
              key: friend.id,
              class: _normalizeClass(['friend-item', { active: selectedFriend.value?.id === friend.id }]),
              onClick: ($event: any) => (selectFriend(friend))
            }, [
              _createVNode(_unref(ElBadge), {
                value: friend.unreadMessageCount || 0,
                hidden: !friend.unreadMessageCount || friend.unreadMessageCount === 0,
                class: "item"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_avatar, {
                      size: 40,
                      src: friend.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                      class: "friend-avatar"
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h4", null, _toDisplayString(friend.name), 1),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(friend.lastMessageContent || '暂无消息'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(friend.lastMessageTime ? formatDate(friend.lastMessageTime) : ''), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["value", "hidden"])
            ], 10, _hoisted_7))
          }), 128))
        ])
      ]),
      (selectedFriend.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_avatar, {
                  size: 40,
                  src: selectedFriend.value.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                  class: "friend-avatar"
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_15, _toDisplayString(selectedFriend.value.name), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_button, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedFriend.value = null)),
                  icon: "Back"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("返回好友列表", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", {
              class: "chat-messages",
              ref_key: "messagesContainerRef",
              ref: messagesContainerRef,
              onScroll: handleScroll
            }, [
              (state.hasMore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (!state.loadingMore)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          onClick: loadMoreMessages,
                          loading: state.loadingMore,
                          class: "load-more-btn"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(state.currentPage > 0 ? '加载更多...' : '点击加载历史消息'), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, "加载中..."))
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.messages, (msg, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: msg.id || index,
                  class: _normalizeClass(["message-item", {
              'my-message': currentUserInfo.value && msg.fromUserId === currentUserInfo.value.id,
              'other-message': currentUserInfo.value && msg.fromUserId !== currentUserInfo.value.id
            }])
                }, [
                  (currentUserInfo.value && msg.fromUserId !== currentUserInfo.value.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_el_avatar, {
                            size: 32,
                            src: msg.fromUserAvatar || selectedFriend.value?.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                            class: "sender-avatar"
                          }, null, 8, ["src"]),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(msg.fromUserName || selectedFriend.value?.name || '未知用户'), 1)
                        ]),
                        _createElementVNode("div", {
                          class: "message-content-wrapper",
                          onClick: ($event: any) => (markSingleMessageAsRead(msg))
                        }, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(msg.content), 1),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(formatDate(msg.createTime)), 1),
                            _createElementVNode("span", _hoisted_26, _toDisplayString(msg.isRead ? '已读' : '未读'), 1)
                          ])
                        ], 8, _hoisted_22)
                      ]))
                    : (currentUserInfo.value && msg.fromUserId === currentUserInfo.value.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_el_avatar, {
                              size: 32,
                              src: currentUserInfo.value.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                              class: "sender-avatar-my"
                            }, null, 8, ["src"]),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(currentUserInfo.value.name || '我'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, _toDisplayString(msg.content), 1),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("span", _hoisted_33, _toDisplayString(formatDate(msg.createTime)), 1),
                              _createElementVNode("span", _hoisted_34, _toDisplayString(msg.isRead ? '已读' : '未读'), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ], 544),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_el_input, {
                modelValue: state.inputMessage,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.inputMessage) = $event)),
                type: "textarea",
                rows: 4,
                placeholder: "请输入消息...",
                maxlength: "500",
                "show-word-limit": "",
                onKeydown: _withKeys(handleSendWithKeydown, ["enter"])
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: sendMessage,
                  disabled: !state.inputMessage.trim()
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("发送", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "welcome-content" }, [
              _createElementVNode("h3", null, "选择好友开始聊天"),
              _createElementVNode("p", null, "从左侧好友列表中选择一位好友开始私信交流")
            ], -1)
          ]))]))
    ])
  ]))
}
}

})